import { render } from "./Cart.vue?vue&type=template&id=f24a8e18&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"

import "./Cart.vue?vue&type=style&index=0&id=f24a8e18&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f24a8e18"]])

export default __exports__